import { render, staticRenderFns } from "./PageKAlert.vue?vue&type=template&id=1b345948"
import script from "./PageKAlert.vue?vue&type=script&lang=js"
export * from "./PageKAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports